export default __webpack_public_path__ + "static/media/2_0116.f28717f9.webp";